module.exports = __webpack_public_path__ + "static/media/recompense1.b3fee5f1.svg";